var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg1Key = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41.89 42.048v.041q0 .095-.006.19v.011l-.003.026a3 3 0 0 1-.017.196q-.008.077-.02.153l-.005.03v.01q-.004.01-.006.022l-.03.166-.01.04a4 4 0 0 1-.046.186l-.003.013-.006.02a4 4 0 0 1-.16.455l-.008.02-.027.057a4 4 0 0 1-.107.217 3 3 0 0 1-.11.188l-.006.01-.077.113q-.023.034-.047.066-.045.06-.09.114-.022.025-.042.05a2 2 0 0 1-.139.146l-.017.015q-.063.06-.129.114l-.052.04q-.05.037-.1.072l-.06.038-.099.057-.03.018q-.03.015-.06.028l-.02.01a2 2 0 0 1-.13.052l-.029.01a1 1 0 0 1-.13.037h-.003q-.038.008-.076.014-.039.009-.078.014-.037.003-.076.005-.037.004-.075.005h-.042q-.059 0-.118-.007l-.123-.013a1.45 1.45 0 0 1-.536-.205 2 2 0 0 1-.187-.136l.013-.007q.05-.026.1-.057.03-.018.06-.038.05-.033.1-.073l.051-.039q.066-.053.13-.114l.016-.015q.072-.07.14-.146l.04-.05a2 2 0 0 0 .138-.179q.04-.056.077-.114l.046-.075q.036-.06.07-.123l.042-.079q.015-.029.028-.057l.037-.08q.018-.038.035-.077.048-.115.092-.236a5 5 0 0 0 .068-.219l.01-.034q.025-.093.045-.186l.01-.04q.016-.08.03-.16l.001-.006.005-.032q.015-.091.025-.182l.005-.043.015-.19a4 4 0 0 0 .007-.19v-.04q.001-.09-.004-.178v-.018a4 4 0 0 0-.019-.23q0-.015-.002-.028a5 5 0 0 0-.038-.252v-.006l-.017-.078-.012-.057a2 2 0 0 0-.032-.132 1 1 0 0 0-.037-.129l-.036-.11-.005-.015-.046-.122-.016-.037-.035-.08-.02-.046-.035-.07-.025-.046-.035-.064-.027-.046-.037-.06-.029-.044-.039-.056-.03-.043-.043-.054-.033-.04-.044-.05q-.016-.02-.034-.038l-.048-.048q-.016-.018-.034-.034-.026-.023-.052-.047l-.027-.023c.45-.236.945-.258 1.392-.01a1 1 0 0 1 .078.044c.533.333.89.98 1.023 1.733l.04.002.001.015q.019.107.031.217l.003.028q.013.114.018.23l.001.004v.015q.003.087.003.176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M33.35 34.477q-.008-.022-.013-.046l-.01-.038zM39.298 32.339c-1.97-.06-3.872.77-5.373 2.01a10 10 0 0 0-.494.43h0c-.37.34-.72.709-1.046 1.094-4.582 5.69-5.355 14.57-1.423 20.806l-1.7-.175c-3.202-4.982-3.172-11.593-.924-16.95l1.665.172c.886-2.018 1.932-3.59 3.42-4.975v-.001c1.574-1.468 3.743-2.505 5.874-2.411z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m35.153 33.144-1.179-.12a10 10 0 0 0-1.964 1.331c-1.624 1.401-2.824 3.241-3.672 5.2l1.665.171c.886-2.018 1.932-3.59 3.42-4.975q0 0 0 0a10 10 0 0 1 2.218-1.557z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m30.636 35.758-.017.022-.127.155q.071-.09.144-.177M32.01 34.356l-.123.108q.061-.056.124-.108M33.415 33.333l-.159.099-.087.054q.123-.08.246-.153M33.664 33.19l-.092.053-.097.055q.095-.057.189-.108M35.673 33.197l-.096.051a4 4 0 0 0-.212.116l-.094.053-.108.062-.008.005-.199.122-.096.061a6 6 0 0 0-.292.195l-.154.11-.153.113-.048.036-.485.393q-.15.127-.297.265l.006.021-.007-.02q-.163.149-.322.308l-.453.476-.048.054-.222.255q-.69.815-1.286 1.795l-.113.19q-.159.267-.308.545l-.085.161-.113.22-.019.04-.102.204q-.063.129-.123.261-.09.196-.178.397l-.02.044-.035-.004c.648-1.504 1.455-2.809 2.371-3.885q.505-.593 1.048-1.09 0 0 0 0 .538-.494 1.108-.89a9 9 0 0 1 1.111-.667z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m30.48 38.783-.12.245M31.1 37.668l-.114.19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M32.608 35.618a9 9 0 0 0-.222.255z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M32.608 35.618a9 9 0 0 0-.222.255"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M32.656 35.564q.13-.146.266-.285.022-.025.048-.05a5 5 0 0 1 .139-.141"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M32.656 35.564q.13-.146.266-.285.022-.025.048-.05a5 5 0 0 1 .139-.141M33.432 34.78h-.001"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M34.214 34.121a10 10 0 0 0-.486.393z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34.214 34.121a10 10 0 0 0-.486.393"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#005DBE",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m21.249 94.186-1.7-.176-.66-.407 1.7.175z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m20.002 93.729-1.107-.12.639.398 1.7.174z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1-key_svg__a",
    width: 3,
    height: 1,
    x: 18,
    y: 93,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.595 93.782-1.7-.175-.006-.005 1.7.175z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1-key_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DBE",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m20.595 93.782-1.7-.175-.006-.005 1.7.175z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m20.595 93.782-1.7-.175-.006-.005 1.7.175z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m19.742 92.117-1.13-.158.277 1.645 1.103.13z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#005DBE",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m19.785 88.903-1.7-.175.526 3.23 1.7.174z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M29.263 56.504 18.084 88.728l1.7.174 11.179-32.223z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    d: "m45.473 44.18-.01-.013-.037-.067-.051-.088-.044-.081-.047-.087-.01-.016-.038-.074-.035-.07-.047-.093-.031-.063-.003-.008-.066-.143-.45-1.008-.508-1.14a12.7 12.7 0 0 1-2.263.134l-.04-.002c.076.414.082.86.014 1.305a4 4 0 0 1-.174.705 3.4 3.4 0 0 1-.338.71c-.41.653-.991 1.029-1.575 1.036h.042q.037-.001.075-.005.038-.002.076-.005.039-.006.078-.014.037-.005.076-.014h.003q.065-.015.13-.038l.028-.01q.066-.022.13-.051l.02-.01.06-.028.03-.018a2 2 0 0 0 .26-.168q.027-.018.052-.04.066-.053.129-.113l.017-.015q.072-.069.139-.147.02-.023.04-.05.047-.053.092-.113.023-.032.047-.066.04-.056.077-.114l.006-.01a11.3 11.3 0 0 0 3.023.295l.127-.005.255-.012.153-.01.232-.018.162-.015.224-.023.038-.005zm-9.83-10.986a9.184 9.184 0 0 0-1.111.667q-.57.396-1.108.889-.544.498-1.048 1.09c-.916 1.077-1.723 2.382-2.371 3.886q-.262.609-.49 1.26c-1.615 4.653-1.39 9.762.285 13.614.028.066.058.127.086.192.247.546.52 1.065.846 1.589q.094.15.193.294l.039.004a8 8 0 0 1-.195-.297 14 14 0 0 1-.846-1.59c-.028-.064-.058-.125-.086-.191a16 16 0 0 1-.166-.4l-.051-.131a13 13 0 0 1-.161-.434q-.047-.13-.091-.262l-.054-.165a12 12 0 0 1-.133-.43l-.084-.297-.037-.136a15 15 0 0 1-.11-.44l-.01-.037a13 13 0 0 1-.09-.408l-.03-.15q-.03-.152-.058-.303-.014-.075-.026-.148a21 21 0 0 1-.071-.44l-.017-.115a16 16 0 0 1-.07-.54l-.012-.123a22 22 0 0 1-.09-1.14l-.004-.122-.012-.367-.003-.174-.002-.325v-.182l.008-.335q0-.082.004-.165a21 21 0 0 1 .02-.433l.004-.066q.013-.24.035-.481l.013-.14q.014-.171.034-.342l.02-.181.038-.304.027-.193.044-.294.03-.191.059-.325q.015-.087.032-.173a16 16 0 0 1 .1-.494 29 29 0 0 1 .149-.62q.045-.18.095-.363l.044-.155a19 19 0 0 1 .167-.56 17 17 0 0 1 .404-1.156l.016-.04a18 18 0 0 1 .242-.591l.02-.044a14 14 0 0 1 .3-.658l.103-.205.019-.04.113-.22.085-.16q.15-.279.308-.546l.113-.19a14 14 0 0 1 1.556-2.103 12 12 0 0 1 .314-.335q.069-.071.139-.141.159-.16.322-.31l.007.022-.006-.021q.147-.138.297-.265l.099-.084q.015-.016.034-.028.031-.026.064-.053l.002-.001q.142-.117.286-.227l.048-.036.153-.113a5 5 0 0 1 .304-.212 6 6 0 0 1 .238-.154l.199-.122.008-.005.108-.062.094-.053q.105-.062.212-.116.101-.053.202-.103l.072-.035q.141-.07.284-.131l.045-.02q.124-.052.249-.101l.077-.03q.144-.056.289-.104l.003-.001q.146-.049.293-.092l.078-.022q.126-.036.252-.066.024-.008.048-.012l.102-.022q.129-.03.259-.054l.133-.022a6 6 0 0 1 .588-.073l.147-.01q.109-.007.218-.01l.18-.003h.057q.073 0 .145.002c-1.238-.042-2.48.255-3.656.855zm-.673 4.76-.06-.08zm-.696-1.092.028.053q.016.03.034.06zm-.398-.828.058.132.052.115a5 5 0 0 1-.11-.247"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m37.867 41.977.02.008m7.586 2.196-.01-.014-.037-.067-.051-.088-.044-.081-.047-.087-.01-.016-.038-.074-.035-.07-.047-.093-.031-.063-.003-.008-.066-.143-.45-1.008-.508-1.14a12.7 12.7 0 0 1-2.263.134l-.04-.002c.076.414.082.86.014 1.305a4 4 0 0 1-.174.705 3.4 3.4 0 0 1-.338.71c-.41.653-.991 1.029-1.575 1.036h.042q.037-.001.075-.005.038-.002.076-.005.039-.006.078-.014.037-.005.076-.014h.003q.065-.015.13-.038l.028-.01q.066-.022.13-.051l.02-.01.06-.028.03-.018a2 2 0 0 0 .26-.168q.027-.018.052-.04.066-.053.129-.113l.017-.015q.072-.069.139-.147.02-.023.04-.05.047-.053.092-.113.023-.032.047-.066.04-.056.077-.114l.006-.01a11.3 11.3 0 0 0 3.023.295l.127-.005.255-.012.153-.01.232-.018.162-.015.224-.023.038-.005zm-9.83-10.987a9.184 9.184 0 0 0-1.111.667q-.57.396-1.108.889 0 0 0 0-.544.498-1.048 1.09c-.916 1.077-1.723 2.382-2.371 3.886q-.262.609-.49 1.26c-1.615 4.653-1.39 9.762.285 13.614.028.066.058.127.086.192.247.546.52 1.065.846 1.589q.094.15.193.294l.039.004a8 8 0 0 1-.195-.297 14 14 0 0 1-.846-1.59c-.028-.064-.058-.125-.086-.191a16 16 0 0 1-.166-.4l-.051-.131a13 13 0 0 1-.161-.434q-.047-.13-.091-.262l-.054-.165a12 12 0 0 1-.133-.43l-.084-.297-.037-.136a15 15 0 0 1-.11-.44l-.01-.037a13 13 0 0 1-.09-.408l-.03-.15q-.03-.152-.058-.303-.014-.075-.026-.148a21 21 0 0 1-.071-.44l-.017-.115a16 16 0 0 1-.07-.54l-.012-.123a22 22 0 0 1-.09-1.14l-.004-.122-.012-.367-.003-.174-.002-.325v-.182l.008-.335q0-.082.004-.165a21 21 0 0 1 .02-.433l.004-.066q.013-.24.035-.481l.013-.14q.014-.171.034-.342l.02-.181.038-.304.027-.193.044-.294.03-.191.059-.325q.015-.087.032-.173a16 16 0 0 1 .1-.494 29 29 0 0 1 .149-.62q.045-.18.095-.363l.044-.155a19 19 0 0 1 .167-.56 17 17 0 0 1 .404-1.156l.016-.04a18 18 0 0 1 .242-.591l.02-.044a14 14 0 0 1 .3-.658l.103-.205.019-.04.113-.22.085-.16q.15-.279.308-.546l.113-.19a14 14 0 0 1 1.556-2.103 12 12 0 0 1 .314-.335q.069-.071.139-.141.159-.16.322-.31l.007.022-.006-.021q.147-.138.297-.265l.099-.084q.015-.016.034-.028.031-.026.064-.053l.002-.001q.142-.117.286-.227l.048-.036.153-.113a5 5 0 0 1 .304-.212 6 6 0 0 1 .238-.154l.199-.122.008-.005.108-.062.094-.053q.105-.062.212-.116.101-.053.202-.103l.072-.035q.141-.07.284-.131l.045-.02q.124-.052.249-.101l.077-.03q.144-.056.289-.104l.003-.001q.146-.049.293-.092l.078-.022q.126-.036.252-.066.024-.008.048-.012l.102-.022q.129-.03.259-.054l.133-.022a6 6 0 0 1 .588-.073l.147-.01q.109-.007.218-.01l.18-.003h.057q.073 0 .145.002c-1.238-.042-2.48.255-3.656.855zm-.673 4.76-.06-.08zm-.696-1.092.028.053q.016.03.034.06zm-.398-.828.058.132.052.115a5 5 0 0 1-.11-.247"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m33.928 34.348-.002.001-.064.053-.034.028-.1.084.486-.393q-.143.111-.286.227m-1.006.931q-.134.14-.266.285l.453-.476-.14.141zM33.876 36.034l.058.132.052.115a5 5 0 0 1-.11-.247"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m33.876 36.034.058.132.052.115a5 5 0 0 1-.11-.247"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m33.876 36.034.058.132.052.115a5 5 0 0 1-.11-.247"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M48.14 43.766c-2.165.632-4.64.855-6.813.323-1.595 2.381-3.838.224-3.44-2.104l-.02-.008.02.007c.215-2.677 3.289-3.792 3.907-.623 1.903.067 3.788-.308 5.722-1.045-2.084-7.847-9.683-10.932-15.131-4.443-4.582 5.69-5.355 14.571-1.423 20.806l-.04-.004.003.003-11.18 32.223c.182 1.074.62 3.835.806 4.876l.659.407.533-.12h0l4.337-1.009.217-.7-1.71-3.302 2.947-.187.655-1.918-.523-3.044 2.026-1.334-.57-2.853 2.01-1.219.709-2.1-1.333-3.312 2.724-.794-1.33-3.329 2.823-.812.674-1.955-.11-2.536c1.599-1.468 1.356-.935 2.046-3.027 7.164.308 11.696-10.047 10.804-16.867z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M48.17 46.18a21 21 0 0 1-.278 2.767l-.359-.837c-.608-.389-1.447-.852-1.65-1.605-2.03-1.195-4.306-2.687-5.602-4.7-1.312-1.822-3.084-6.807-4.072-8.87 3.323-1.36 6.874-.09 9.072 2.895q-.18.126-.361.245c-1.5-.776-1.224.74-.665 1.633.753 1.299 2.018 2.805 3.432 3.43.369 1.556.544 3.256.485 5.043z",
    opacity: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M55.931 42.567c.21-1.619-2.41-4.408-3.845-5.013-.207-.075-.469-.144-.656.004l-2.028 1.738c1.284-.639 5.234 3.961 4.408 5.142l2.028-1.738a.4.4 0 0 0 .094-.132z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M65.042 57.705c.001.13 2.174-1.818 2.224-1.838-.508.33-1.137-.09-1.594-.344l-2.027 1.738c.416.243.896.536 1.395.444z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M63.717 54.302 61.69 56.04l1.954 1.22 2.028-1.737z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m61.8 56.576 2.027-1.738a.1.1 0 0 1-.028.014l-.007.002q-.016.003-.036.002h-.008l-.032-.007q-.006 0-.013-.004l-.024-.009-.016-.006-.02-.009-.02-.01-.02-.01-.03-.018-.745-.465-2.028 1.738.744.465.015.01.017.008.02.011.005.003.015.007.02.01.005.001.011.004.024.01.006.001.006.001.032.006.006.001h.002q.02.001.036-.002.003 0 .007-.002a.1.1 0 0 0 .028-.014"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.774 31.986-2.027 1.738c-.194-.489-.474-1.084-.23-1.597a.5.5 0 0 1 .088-.107l2.027-1.738a.5.5 0 0 0-.134.2c-.145.515.082 1.024.276 1.504"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m54.402 49.05-2.029 1.74.84.557 2.029-1.738z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M54.31 48.987a2.24 2.24 0 0 1-.7-.969l-2.027 1.738c.157.407.422.79.79 1.033l2.029-1.738q-.044-.028-.092-.064"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m53.61 48.018-2.027 1.74-2.273-1.454 2.028-1.739z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m64.46 62.037-2.028 1.739 1.64-.316 2.027-1.74z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m51.337 46.565-2.028 1.74a12.8 12.8 0 0 1-4.256-4.928c.08-.034 1.934-1.726 2.038-1.713.27.59.62 1.153 1.01 1.694.898 1.224 1.96 2.38 3.236 3.207"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m47.092 41.665-.035.013-.037.013.06-.052q.007.013.012.025"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M66.102 65.662 64.074 67.4l1.577-.313 2.027-1.74zM72.065 79.623l-2.027 1.738 2.147.286 2.028-1.738z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#005DBE",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m72.68 84.02-.254.19-1.601 1.41 3-.295 2.029-1.738-2.645.25z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m55.241 49.61-2.028 1.737L66.21 80.465l2.027-1.74z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m75.561 82.972-3.497-3.348 2.147.286-.759-1.685-2.409-2.92.682-.927-2.32-2.75.745-.822-.837-1.846-3.213-3.298 1.577-.314-3.219-3.311 1.64-.316-.77-1.718-1.756-2.381.25-1.005-.996-2.3c.162.1.588.368.744.465.46.269.23-.235.147-.48.82.418 2.302 1.71 3.257 1.682.705-.146.54-.841.157-1.796l-4.312-9.666c-.699-1.626-2.735-4.003-4.257-4.925L44.22 30.635c-.964-.59-1.745-.74-1.769.18-.193.43 3.963 9.183 4.178 9.815.397.92.854 1.923 1.471 2.729 1.286 1.974 3.517 3.47 5.51 4.66.212.735 1.031 1.205 1.63 1.59l12.996 29.117 2.534 3.094c.002 0 1.305 1.584 1.308 1.583l.773.48c.06-.007 2.828-.278 3.001-.295zM55.037 39.756q-.05-.067-.098-.134zm-.498-.725q-.056-.088-.11-.176zm-.322-.53.037.066-.124-.217zm-.37-.694q.045.093.093.187-.048-.093-.094-.187zm2.125 4.547c-.42 1.763-3.943-2.298-4.196-3.056-.547-.83-.88-2.403.585-1.618q.179-.124.355-.255c.06.207.133.41.207.612 1.332 1.103 2.765 2.55 3.05 4.317"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "m75.561 82.972-3.497-3.348 2.147.286-.759-1.685-2.409-2.92.682-.927-2.32-2.75.745-.822-.837-1.846-3.213-3.298 1.577-.314-3.219-3.311 1.64-.316-.77-1.718-1.756-2.381.25-1.005-.996-2.3c.162.1.588.368.744.465.46.269.23-.235.147-.48.82.418 2.302 1.71 3.257 1.682.705-.146.54-.841.157-1.796l-4.312-9.666c-.699-1.626-2.735-4.003-4.257-4.925L44.22 30.635c-.964-.59-1.745-.74-1.769.18-.193.43 3.963 9.183 4.178 9.815.397.92.854 1.923 1.471 2.729 1.286 1.974 3.517 3.47 5.51 4.66.212.735 1.031 1.205 1.63 1.59l12.996 29.117 2.534 3.094c.002 0 1.305 1.584 1.308 1.583l.773.48c.06-.007 2.828-.278 3.001-.295zM55.037 39.756q-.05-.067-.098-.134zm-.498-.725q-.056-.088-.11-.176zm-.322-.53.037.066-.124-.217zm-.37-.694q.045.093.093.187-.048-.093-.094-.187zm2.125 4.547c-.42 1.763-3.943-2.298-4.196-3.056-.547-.83-.88-2.403.585-1.618q.179-.124.355-.255c.06.207.133.41.207.612 1.332 1.103 2.765 2.55 3.05 4.317"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m75.561 82.972-3.497-3.348 2.147.286-.759-1.685-2.409-2.92.682-.927-2.32-2.75.745-.822-.837-1.846-3.213-3.298 1.577-.314-3.219-3.311 1.64-.316-.77-1.718-1.756-2.381.25-1.005-.996-2.3c.162.1.588.368.744.465.46.269.23-.235.147-.48.82.418 2.302 1.71 3.257 1.682.705-.146.54-.841.157-1.796l-4.312-9.666c-.699-1.626-2.735-4.003-4.257-4.925L44.22 30.635c-.964-.59-1.745-.74-1.769.18-.193.43 3.963 9.183 4.178 9.815.397.92.854 1.923 1.471 2.729 1.286 1.974 3.517 3.47 5.51 4.66.212.735 1.031 1.205 1.63 1.59l12.996 29.117 2.534 3.094c.002 0 1.305 1.584 1.308 1.583l.773.48c.06-.007 2.828-.278 3.001-.295zM55.037 39.756q-.05-.067-.098-.134zm-.498-.725q-.056-.088-.11-.176zm-.322-.53.037.066-.124-.217zm-.37-.694q.045.093.093.187-.048-.093-.094-.187zm2.125 4.547c-.42 1.763-3.943-2.298-4.196-3.056-.547-.83-.88-2.403.585-1.618q.179-.124.355-.255c.06.207.133.41.207.612 1.332 1.103 2.765 2.55 3.05 4.317"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M62.82 44.521c-1.728-4.16-7.086-6.57-10.565-8.866q-.009.996.164 1.983.15-.104.298-.214c.059.207.133.41.206.612a9.8 9.8 0 0 1 2.755 3.285c.88 1.814-.35 1.782-1.604.69 2.232 3.77 6.34 6.904 11.31 8.261zm-8.92-6.606-.053-.109zm.23.434q.064.107.124.217-.063-.11-.123-.217m.317.537-.019-.032.11.176zm.581.858.01.011z",
    opacity: 0.4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m70.772 81.82-2.535-3.094-2.027 1.739 2.534 3.093 1.305 1.583 1.783-1.53.245-.21z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m71.67 83.752-1.62 1.388.775.48 1.62-1.388z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M58.514 50.983c-.282-.631-.772-1.352-1.332-2s-1.194-1.228-1.77-1.588l15.382 34.437.46.974.452.918.748.493.254-.212.158-.112.334-.031-14.686-32.88z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m73.2 83.863-.464.157-.078.008L57.76 50.757c-.282-.631-.772-1.351-1.332-2a11 11 0 0 0-.764-.794l-.253-.568c.575.36 1.21.94 1.77 1.588s1.05 1.369 1.332 2l14.686 32.88z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M63.092 32.81v.08q0 .014-.002.028-.001.023-.005.045 0 .015-.004.028a1 1 0 0 1-.03.115l-.008.02-.016.038-.014.03c-.094.183-.27.325-.527.406l-.008-.026-.012-.032-.02-.053-.015-.033-.026-.055-.016-.031q-.016-.031-.035-.064l-.013-.024a2 2 0 0 0-.116-.175l-.043-.057-.007-.01-.026-.033a2.5 2.5 0 0 0-.256-.276l-.105-.097-.044-.04a4 4 0 0 0-.322-.245l-.072-.047-.109-.07-.077-.045a3 3 0 0 0-.27-.145l-.06-.03a5 5 0 0 0-.239-.104l-.056-.021a4 4 0 0 0-.177-.064q-.04-.014-.08-.025l-.155-.045-.086-.021a4 4 0 0 0-.317-.06 1 1 0 0 0-.106-.012l-.037-.005-.014-.001a3 3 0 0 0-.165-.008h-.03q-.084-.001-.164.005l-.033.003a1.362 1.362 0 0 0-.311.054q-.029.008-.054.018a1 1 0 0 1-.057-.334.75.75 0 0 1 .08-.338l.004-.008a1 1 0 0 1 .053-.084q0-.003.002-.003l.011-.014q.004-.007.011-.013a1 1 0 0 1 .051-.057l.007-.008.006-.007.01-.008h.001l.01-.008q.02-.02.043-.037a.85.85 0 0 1 .139-.088q.012-.008.026-.013l.013-.006.014-.006.034-.015.002-.001.018-.007.052-.02q.018-.007.037-.012l.004-.002.034-.01.032-.007.041-.01.077-.016.076-.012.045-.005.073-.006.067-.004q.063-.002.127-.001.04 0 .082.003l.12.009.014.002q.095.009.191.025l.078.014q.01.001.021.004l.133.029.086.02a5 5 0 0 1 .236.07q.046.014.088.032l.044.016.044.017.042.015.014.006a4 4 0 0 1 .386.178q.053.026.104.055l.018.009.027.016q.057.03.111.066.055.033.11.069a3 3 0 0 1 .212.149q.042.03.082.063.039.03.076.062l.022.019.052.046q.049.043.095.088l.052.05q.063.063.121.128.03.034.058.068.089.105.157.208l.008.01.015.025.033.055q.03.048.054.096l.035.07.021.05.02.048a1 1 0 0 1 .04.12q.007.03.013.059a1 1 0 0 1 .018.102z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M52.961 34.248v.015l.002-.063q0 .024-.002.048m.886 3.558zm.37.694-.087-.15.124.216zm.722 1.121.09.123.008.011zm4.038-8.76-.006.006zm2.515-1.89a16 16 0 0 0-1.097-.028 29 29 0 0 1-1.126 1.735l.018-.007q.025-.011.052-.019.018-.008.037-.013l.038-.01q.016-.006.032-.009l.041-.01.077-.016.076-.012.045-.005.073-.006.067-.004q.063-.002.127 0 .04 0 .082.002.04 0 .083.005l.015.001.006.001.015.002.007.001q.146.012.3.043.225.045.453.121.046.015.088.031l.044.016q.044.015.086.032l.014.006a4 4 0 0 1 .386.178 2 2 0 0 1 .15.08q.056.031.11.066.055.033.11.07a3 3 0 0 1 .212.148q.042.03.082.063l.076.062q.011.009.022.02.027.022.052.045a2 2 0 0 1 .147.138q.063.063.121.128.03.034.058.068.089.105.157.208a27 27 0 0 0 .497-.782l.042-.067.052-.088q.135-.22.265-.444.037-.06.073-.124.16-.276.314-.555l.02-.036.15-.275.05-.093.137-.262c-1-.213-1.985-.35-2.937-.406zM73.515 49.3l.233.001h.083zm4.33-.685-.167.066a7 7 0 0 0 .345-.136zm.637-.284.017-.008.047-.025zm-.09.046q.034-.016.07-.035 0 0 .003-.002h.002l.002-.003zm.826-.484-.094.066zm-1.013.57-.083.04q.085-.038.168-.078zm1.091-.623q.014-.007.025-.017l.036-.027zm1.381-1.484"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M80.816 46.107c-1.68 3.079-5.742 3.408-8.878 3.093-6.62-.862-13.132-4.318-17.111-9.741a12.4 12.4 0 0 1-.98-1.653h0c-2.641-5.17.839-8.951 6.549-8.863a29 29 0 0 1-1.126 1.735.86.86 0 0 0-.378.28q-.002-.001-.002.004c-.613 1.454 1.672 2.61 2.839 2.709 1.049.149 1.782-.645 1.1-1.568a32 32 0 0 0 1.6-2.726c6.96 1.235 19.299 9.038 16.387 16.73"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m52.964 34.2-.002.063v-.015zM55.038 39.755l-.01-.01zM78.47 48.336l.013-.006-.015.008-.002.001-.004.002-.07.035q.04-.02.078-.04M78.547 48.297l-.047.025-.017.008zM79.357 47.796l-.036.027-.025.017z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M80.8 46.138c-2.79 6.844-13.103 4.027-18.123 1.403-5.008-2.56-13.111-9.212-9.202-15.404-1.212 2.426-.092 5.253 1.352 7.322 4.438 6.37 16.08 12.18 23.639 8.88.97-.482 1.834-1.23 2.334-2.201M53.848 37.807h-.001z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m54.217 38.5.037.067-.124-.217zM54.94 39.621l.098.134-.01-.01zM77.846 48.614q.09-.034.178-.07a7 7 0 0 1-.345.136zM78.206 48.462l.085-.038-.168.077zM78.47 48.336l.013-.006-.015.008-.002.001-.004.002-.07.035q.04-.02.078-.04M78.483 48.33l.064-.033-.047.025zM79.219 47.892q.026-.016.052-.035a4 4 0 0 1-.147.101zM79.296 47.84l.061-.044-.036.027zM80.733 46.263l-.086.144.03-.051q.029-.046.055-.093"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m65.752 47.612-.551 1.08c2.188.87 4.426 1.436 6.526 1.622l.55-1.08c-2.1-.186-4.337-.752-6.525-1.622"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M74.436 38.302c-2.225-1.068-4.077-1.746-5.623-2.135a16 16 0 0 0-.898-.2c-1.31-.252-2.37-.273-3.227-.137-3.948.625-3.596 4.384-3.579 4.581 2.091 1.011 3.854 1.672 5.342 2.066q.465.123.895.212c1.397.29 2.522.32 3.423.176 3.95-.625 3.68-4.367 3.665-4.564zm-4.96 3.08c-.532.084-1.163-.005-1.785-.224a5.6 5.6 0 0 1-.856-.386 4.8 4.8 0 0 1-1.331-1.075c-.946-1.123-.704-2.202.538-2.399.466-.074 1.002-.016 1.541.143.291.087.584.203.867.343.602.302 1.16.717 1.566 1.199.957 1.139.72 2.199-.54 2.398z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M68.499 33.418 65.79 45.457l.86.365 2.71-12.039z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m38.73 41.271-.533-.416.013-.028q.25.234.52.444"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.8 32.371c-1.422-.143-2.82.141-4.157.823-.32-.033-1.332-.137-1.668-.17 1.75-1 3.892-.945 5.825-.653"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M62.59 10.605C58.268 7.25 51.893 9.05 47.668 11.853c-6.865 4.56-12.172 12.295-12.514 20.679a8.7 8.7 0 0 0-2.012.974c-1.364-9.816 5.952-20.212 14.437-24.59 3.26-1.637 7.219-2.556 10.734-1.205 1.425.447 3.089 2.03 4.277 2.894"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M65.13 16.574c-.037-2.31-.56-4.667-1.826-6.624a9 9 0 0 0-2.024-2.226C48.156-.552 29.557 19.897 32.01 34.355q.54-.466 1.13-.85C31.69 23.152 40.033 11.8 49.453 8.088c3.48-1.343 7.79-1.63 10.883.76 5.994 4.257 3.609 15.743-1.065 21.83-.17.238-.34.48-.517.714.012.372.173.657.443.984q.66-.855 1.263-1.753 0 0 0 0c2.75-4.147 4.709-9.018 4.672-14.049m-12.156 21.59q-.026-.065-.05-.128a9 9 0 0 1-.207-.612c-.442.324-.9.64-1.356.93.086.305.246.644.416.943q.659-.431 1.295-.899a7 7 0 0 1-.098-.235m-8.878 3.066c-1.936.29-3.995.153-5.777-.619a3.8 3.8 0 0 0-.431 1.374c2.129.822 4.499.834 6.716.384zm9.38-4.272"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m53.872 37.856-.025-.05h0z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m53.94 37.994-.068-.139"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m54.255 38.567-.124-.217q.063.106.124.217M45.54 44.296c-2.695.328-5.541-.17-7.682-1.843q0-.233.03-.468a10 10 0 0 0 2.246.572c1.485.204 3.003.11 4.47-.187.257.57.603 1.406.937 1.925M54.413 40.736q-.502.34-1.018.657c-.63-.632-1.221-1.39-1.618-2.095q.659-.431 1.295-.9c.355.828.816 1.607 1.34 2.338M54.54 39.03q-.056-.086-.11-.175zM55.038 39.755q-.05-.067-.098-.134zM67.343 18.535c-.05 5.496-2.384 10.77-5.614 15.136-.881-.073-1.923-.582-2.533-1.295q.66-.856 1.263-1.753 0 0 0 0c4.27-6.35 7.584-16.994.9-22.836 4.114 2.812 5.944 5.671 5.984 10.748"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m64.997 19.05 2.21 1.724c-.199 1.639-.615 3.372-1.264 5.164l-.085.232-2.209-1.723q.044-.116.085-.232c.65-1.792 1.066-3.525 1.263-5.164"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M33.883 52.93c.485.304.825.872.979 1.542a4 4 0 0 1-.125 2.165L21.743 94.065l-.533.12-1.218-.438-.226-1.638.507.023z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34.736 56.638 21.743 94.066l-.47.106 12.88-37.101c.25-.72.28-1.497.125-2.166-.115-.501-.335-.946-.642-1.265l.246-.708c.485.303.825.87.98 1.54a4 4 0 0 1-.126 2.166"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m53.071 38.399-.235.17-.118.085q-.205.148-.412.289l-.065.045-.238.16-.217.143-.01.007a5 5 0 0 1-.244-.48 3.4 3.4 0 0 1-.172-.463 23 23 0 0 0 1.001-.675q.179-.124.355-.255.01.04.024.08l.032.104a8 8 0 0 0 .094.272c.02.052.042.146.057.156l.046.119.004.008q.046.117.098.235"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M54.412 40.736q-.207.14-.416.277l-.037.024-.08.052-.39.246-.095.058c-.63-.632-1.22-1.39-1.618-2.095l.01-.007.217-.142q.12-.08.238-.161l.065-.045q.207-.141.412-.29.06-.04.118-.083l.235-.171.014.034.041.09q.041.096.085.19l.052.107q.041.088.086.175l.057.113q.045.087.093.175l.06.11.106.187.057.1q.069.117.142.234l.032.053q.09.144.184.288l.056.082a13 13 0 0 0 .217.315zM42.782 32.01l-2.027 1.738 4.306 9.653 2.027-1.738z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5FAFF",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeWidth: 0.067,
    d: "m76.743 26.72-1.028.096a2.585 2.585 0 0 0-2.318 2.216l-.143 1.023c-.02.153-.244.148-.259-.006l-.097-1.028a2.585 2.585 0 0 0-2.215-2.318l-1.023-.143c-.153-.02-.148-.244.006-.259l1.028-.096a2.585 2.585 0 0 0 2.318-2.216l.143-1.022c.02-.154.244-.149.259.005L73.51 24a2.585 2.585 0 0 0 2.216 2.318l1.022.143c.154.02.149.244-.005.259ZM81.343 31.054l-.679.064c-.787.074-1.42.68-1.53 1.462l-.094.675c-.014.101-.161.098-.17-.004l-.065-.678a1.706 1.706 0 0 0-1.462-1.53l-.675-.094c-.101-.014-.098-.162.004-.171l.678-.064a1.706 1.706 0 0 0 1.53-1.463l.094-.675c.014-.1.162-.098.171.004l.064.679c.075.787.68 1.42 1.463 1.53l.675.094c.1.014.098.161-.004.17Z"
  })));
};
export default Svg1Key;